const KIND_TAG = {
  RIPD: 'ripd',
  ROPA: 'ropa',
  COMPLIANCE: 'compliance',
  MANAGEMENT: 'management',
  CONTROL: 'control',
  FRAGILITY: 'fragility',
  TRAINING: 'training',
}

const KIND = {
  RIPD: 'ripd',
  ROPA: 'ropa',
  COMPLIANCE: 'compliance',
  MANAGEMENT: 'management',
  CONTROL: 'control',
  INCIDENT: 'incident',
  FRAGILITY: 'fragility',
  TRAINING: 'training',
  LIA: 'lia',
  CONSENT: 'consent',
  ACCEPTANCE: 'acceptance',
  AUDIT: 'audit',
  PARTNER: 'partner',
  COOKIES_CONSENTS: 'cookies_consents',
  COOKIES_TAGS: 'cookies_tags',
  PHISHING: 'phishing',
  PRIVACY_BY_DESIGN: 'privacy_by_design',
  KANBAN_TASKS: 'kanban_tasks',
}

// O enum da API é zip_file porque `zip` colide com o ActiveRecord.
const FILE_TYPE_LABELS = {
  zip_file: 'zip',
}

const DOWNLOAD_ONLY_ID_ACTION = 1
const DESTROY_VERSION_ID_ACTION = 2
const VERSION_EXISTS_ACTION_OPTIONS = [
  {
    id: DOWNLOAD_ONLY_ID_ACTION,
    name: 'Apenas baixar um novo relatório',
  },
  {
    id: DESTROY_VERSION_ID_ACTION,
    name: 'Excluir versão atual e gerar uma nova versão',
  },
]

const KIND_ACCEPTED = {
  revoked: 'Revogado',
  authorized: 'Autorizado',
  pending: 'Pendente',
  soft_deleted: 'Excluído',
}

const KIND_ACCEPTED_CLASS_NAME = {
  revoked: 'revokedStatus',
  authorized: 'authorizedStatus',
  pending: 'pendingStatus',
  soft_deleted: 'softDeletedStatus',
}

const reportVersions = {
  DESTROY_VERSION_ID_ACTION,
  KIND_TAG,
  KIND,
  VERSION_EXISTS_ACTION_OPTIONS,
  DOWNLOAD_ONLY_ID_ACTION,
  FILE_TYPE_LABELS,
  KIND_ACCEPTED,
  KIND_ACCEPTED_CLASS_NAME,
}

export default reportVersions
